import { lazy } from "react";
import Loadable from "app/components/Loadable";

const WhatsAppInboxPage = Loadable(lazy(() => import("./WhatsAppInboxPage")));

const WhatsAppInboxRoutes = [
  {
    path: "/admin/whatsapp-inbox",
    element: <WhatsAppInboxPage />,
  },
];

export default WhatsAppInboxRoutes;
